import {
  Action,
  canAccessServiceRequestAttachment,
  type Actor,
  type ServiceRequestResource,
} from 'domains-work-order-authorization';

export interface AttachmentAccess {
  canRead: boolean;
  canCreate: boolean;
  canDelete: boolean;
}

interface AttachmentAccessRequest {
  actor: Actor;
  resource: ServiceRequestResource;
  isEnforced: boolean;
}

const ALLOWED: AttachmentAccess = {
  canRead: true,
  canCreate: true,
  canDelete: true,
};

export const getAttachmentAccess = ({
  actor,
  resource,
  isEnforced,
}: AttachmentAccessRequest): AttachmentAccess => {
  if (!isEnforced) return ALLOWED;

  const can = (action: Action) =>
    canAccessServiceRequestAttachment({ actor, resource, action });

  return {
    canRead: can(Action.Read),
    canCreate: can(Action.Create),
    canDelete: can(Action.Delete),
  };
};
